// extracted by mini-css-extract-plugin
export default {"aggregatedData":"PlayerBattedBallSLGTable_aggregatedData__AmMx-"};